import { render, staticRenderFns } from "./Sanctions.vue?vue&type=template&id=b6795864&scoped=true&"
import script from "./Sanctions.vue?vue&type=script&lang=js&"
export * from "./Sanctions.vue?vue&type=script&lang=js&"
import style0 from "./Sanctions.vue?vue&type=style&index=0&id=b6795864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6795864",
  null
  
)

export default component.exports